// @flow
import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import type { TagInfoType } from '../../models/Tag'
import Link from 'next/link'

type TagPillRowType = {
  ...TagInfoType,
  small?: boolean
}
export function TagPill (props: TagPillRowType): React.Node {
  return (
    <TagPillButton $small={!!props.small}><Link passHref={true} href={props.slug}>{props.title}</Link></TagPillButton>
  )
}

export const TagPillButton = styled.div`
  font-family: "Good Sans Regular";
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  border-radius: 100px;
  border: 1px solid ${colors.white};
  &:hover {
    opacity: 0.4;
  }  
  a {
    text-decoration: none;
    color: ${colors.white};
  }
  ${(props: any): string => props.$small
    ? `padding: 5px 10px; font-size: 10px;`
    : `padding: 10px 15px; font-size: 12px;`
  };

  ${(props: any): string => config(props).media.md`
    font-size: ${(props: any): string => props.$small ? `12px` : `14px`};
  `}
`

type TagPillRowPropsType = {
  id: string,
  small?: boolean,
  tags: TagInfoType[]
}
export function TagPillRow (props: TagPillRowPropsType): React.Node {
  return (
    <Container className='TagPillRow'>
        {props.tags.map((tag: TagInfoType, index: number): React.Node => {
          return (
            <TagPill {...tag} key={`tag-pill-row-${props.id}-${index}`} small={!!props.small} />
          )
        })}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 6px;
  ${(props: any): string => config(props).media.md`
    grid-gap: 8px;
  `}
`
